import {Tooltip} from '@mintdata/mint-kit/impl/components/tooltip/Tooltip';
import {ImgIcon} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcon';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/toggler/Toggler.less');
const cx = classnames.bind(styles);

export class TogglerProps
{
    className?:string;
    tooltipClassName?:string;
    textClassName?:string;
    iconClassName?:string;
    position?:TogglerPosition;
    isPressed?:boolean;
    isDisabled?:boolean;
    onClick?:(event:React.MouseEvent<HTMLButtonElement>) => void;
    icon?:ImgIcons;
    text?:string | JSX.Element;
    isBlock?:boolean;
    tooltip?:string;
    noWrap?:boolean;
}

export enum TogglerPosition
{
    Single = 'single',
    Left = 'left',
    Middle = 'center',
    Right = 'right',
}

export class Toggler extends React.Component<TogglerProps, any>
{
    constructor(props:TogglerProps)
    {
        super(props);
    }

    public render():JSX.Element
    {
        const {
            className,
            tooltipClassName,
            textClassName,
            iconClassName,
            onClick,
            isPressed,
            icon,
            text,
            isDisabled,
            position = TogglerPosition.Single,
            isBlock = false,
            tooltip,
            noWrap,
        } = this.props;

        const button = (
            <button
                className={cx('base', {isPressed, [position]: true, isBlock, isDisabled}, className)}
                onClick={onClick}
                disabled={isDisabled}
            >
                {icon && <ImgIcon icon={icon} className={cx(iconClassName)} />}
                {text ? <span className={cx('text', textClassName, {noWrap})}>{text}</span> : null}
            </button>
        );

        return tooltip && !isDisabled
            ? <Tooltip content={tooltip} targetClassName={cx('tooltip', {isBlock}, tooltipClassName)}>{button}</Tooltip>
            : button;
    }
}

